import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import usePremiumServiceEnabled from 'hooks/premium-service';
import { buildChildSitePath } from 'constants/route-paths';

const usePremiumServiceGuard = (serviceName) => {
  const { siteSlug } = useParams();
  const history = useHistory();

  const isEnabled = usePremiumServiceEnabled(serviceName);

  useEffect(() => {
    if (!isEnabled) {
      history.push(siteSlug ? buildChildSitePath(siteSlug) : '/');
    }
  }, [isEnabled, history, siteSlug]);
};

export default usePremiumServiceGuard;
